export const googleAuth = {
  signIn() {
    return new Promise((resolve) => {
      if (document.querySelector('#google-signin-script')) {
        this.performSignIn(resolve)
        return
      }

      const script = document.createElement('script')
      script.id = 'google-signin-script'
      script.src = 'https://accounts.google.com/gsi/client'
      script.onload = () => {
        this.performSignIn(resolve)
      }
      script.onerror = () => {
        resolve({ success: false, error: 'Failed to load Google Sign-In script' })
      }
      document.head.appendChild(script)
    })
  },

  performSignIn(resolve) {
    window.google.accounts.id.initialize({
      client_id: process.env.VUE_APP_GOOGLE_CLIENT_ID,
      callback: (response) => {
        const payload = JSON.parse(atob(response.credential.split('.')[1]))
        resolve({
          success: true,
          user: {
            id: payload.sub,
            email: payload.email,
            name: payload.name,
            picture: payload.picture,
            token: response.credential
          }
        })
      }
    })

    // Create temporary button container
    const container = document.createElement('div')
    container.style.position = 'fixed'
    container.style.top = '-1000px'
    document.body.appendChild(container)

    window.google.accounts.id.renderButton(container, {
      theme: 'outline',
      size: 'large'
    })

    // Trigger the button click
    setTimeout(() => {
      const button = container.querySelector('div[role="button"]')
      if (button) {
        button.click()
      } else {
        resolve({ success: false, error: 'Could not create Google Sign-In button' })
      }
      document.body.removeChild(container)
    }, 100)
  }
}